import { FC, useEffect, useState } from "react";
import HorizontalPadding from "../../components/HorizontalPadding";
import {
  ManifestDetailInterface,
  ManifestHeaderInterface,
} from "../../interfaces/ManifestInterface";
import { useAppSelector } from "../../store/hooks";
import {
  getManifestDetail,
  getPendingDispatchs,
} from "../../services/manifestServices";
import ManifestHeaderTable from "../Manifest/ManifestHeaderTable";
import { alertService, loaderService } from "../../services";
import ManifestDetailModal from "../Manifest/ManifestDetailModal";

const PendingDispatch: FC = () => {
  const user = useAppSelector((state) => state.user);
  const loading = loaderService.useIsLoading();
  const [openModal, setOpenModal] = useState(false);
  const [dispatch, setDispatch] = useState<ManifestHeaderInterface>();
  const [details, setDetails] = useState<ManifestDetailInterface[]>([]);
  const [pendingDispatchList, setPendingDispatchList] = useState<
    ManifestHeaderInterface[]
  >([]);

  const handleDispatchClick = async (dispatch: ManifestHeaderInterface) => {
    const masterShipmentHeaderCode = dispatch.masterShipmentHeaderCode;

    if (loading) {
      return;
    }
    if (!masterShipmentHeaderCode) {
      alertService.error("Parece que el despacho no tiene un código asociado");
      return;
    }

    loaderService.start();
    const dispatchDetails = await getManifestDetail(
      masterShipmentHeaderCode,
      true,
      true
    );
    loaderService.stop();

    if (
      dispatchDetails === null ||
      !dispatchDetails[0] ||
      !dispatchDetails[0].manifestDetail
    ) {
      alertService.error("Hubo un error obteniendo los detalles del despacho");
      return;
    }

    const sorteredDispatchDetails = dispatchDetails[0].manifestDetail.sort(
      (a, b) => {
        const aValue = a.lineSeqNumber ?? -Infinity;
        const bValue = b.lineSeqNumber ?? -Infinity;

        return bValue - aValue;
      }
    );

    setDispatch(dispatch);
    setDetails(sorteredDispatchDetails);
    setOpenModal(true);
  };

  useEffect(() => {
    const destinationBUCode = user.businessUnit?.code;
    if (!destinationBUCode) {
      return;
    }

    const afunction = async () => {
      const response = await getPendingDispatchs(destinationBUCode);

      if (response.didError || !response.model) {
        return;
      }

      setPendingDispatchList(response.model);
    };

    afunction();
  }, [user.businessUnit?.code]);

  return (
    <main className="lg:pl-72 pb-32">
      <div className="py-6 sm:px-6 lg:px-8 bg-white relative flex items-center justify-between h-32">
        <div>
          <header className="text-2xl font-bold text-gray-700 ">
            Despachos a mi tienda
          </header>
          <p className="text-gray-600 font-semibold">Últimos 7 días</p>
        </div>
      </div>

      <HorizontalPadding paddingTop>
        <div>
          <div className="p-6 rounded-lg bg-white border">
            <ManifestHeaderTable
              hideStatus
              manifests={pendingDispatchList}
              onManifestClick={handleDispatchClick}
            />
          </div>
        </div>
      </HorizontalPadding>

      {dispatch && (
        <ManifestDetailModal
          showShipper
          showConsignee
          showDeliveryAddress
          printRawExcel
          openModal={openModal}
          setOpenModal={setOpenModal}
          manifest={dispatch}
          detailData={details}
        />
      )}
    </main>
  );
};

export default PendingDispatch;
